export default __webpack_public_path__ + "static/media/money-bag.57ec6782.svg";